module.exports = __webpack_public_path__ + "static/footer-top-dots-437714c05726451e2f9a4dd74d52d269.svg";